import { Divider, useTheme } from "@mui/material";

export const Line = () => {
  const theme = useTheme();
  return (
    <Divider
      sx={{
        width: "100%",
        borderStyle: "dashed",
        borderColor: `${theme.palette.customColor?.dark}`,
        borderWidth: "0px 0px thin",
      }}
    />
  );
};
